function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6465"
    },
    d: "M464.612,0H47.386C21.216,0,0,21.216,0,47.386v417.226c0,26.172,21.216,47.386,47.386,47.386h417.226 c26.17,0,47.386-21.216,47.386-47.386V47.386C512,21.216,490.784,0,464.612,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "371.949,193.255 318.744,140.051 255.999,202.796 193.255,140.051 140.051,193.255  202.796,255.999 140.051,318.744 193.255,371.949 255.999,309.204 318.744,371.949 371.949,318.744 309.204,255.999 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M63.521,464.612V47.386C63.521,21.216,84.736,0,110.907,0H47.386 C21.216,0,0,21.216,0,47.386v417.226c0,26.17,21.216,47.386,47.386,47.386h63.521C84.736,512,63.521,490.784,63.521,464.612z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3b7e169d54fd3432b3cbd3d0eb579e45.svg";
export { ForwardRef as ReactComponent };